import TWButton from "./TWButton"

type CodeFormType = {
  validateCode: any,
  loading: boolean,
  code: string,
  setCode: any
}

export default function CodeForm({ validateCode, loading, code, setCode }: CodeFormType) {

  return (
    <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Introduce tu código para continuar</h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 space-y-6">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700"> Código </label>
            <div className="mt-1">
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </div>
          </div>

          <div>
            <TWButton
              label="Continuar"
              loading={loading}
              action={() => validateCode(code)}
              type="button"
            ></TWButton>
          </div>
        </div>
      </div>
    </div>
  )
}